import styled from 'styled-components';

export const CheckBoxWrapper = styled.label`
  &&& {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
`;

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const Icon = styled.i`
  color: #fff;
  width: 100%;
  margin: auto;
  text-align: center;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
  width: ${props => (props.small ? 16 : 24)}px;
  height: ${props => (props.small ? 16 : 24)}px;
  background: ${props => (props.checked ? '#318DEA' : '#fff')};
  border-radius: 2px;
  transition: all ease 0.3s;
  border-style: solid;
  border-width: ${({ small }) => (small ? '1px' : '2px')};
  border-color: ${({ checked }) => (checked ? '#318DEA' : '#8F959F')};

  ${Icon} {
    font-size: ${props => (props.small ? 10 : 18)}px;
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;

export const ChildrenContainer = styled.span`
  margin-left: 5px;
`;
